<template>
  <div class="legal-notice">
    <h1>{{ $t('legalNotice.title') }}</h1>
    <section>
      <h2>{{ $t('legalNotice.publisher') }}</h2>
      <p>{{ $t('legalNotice.publisherText1') }}</p>
      <p><strong>WEBEASY LLC</strong></p>
      <p>{{ $t('legalNotice.publisherText2') }}</p>
      <p>{{ $t('legalNotice.publisherText3') }}</p>
      <p><strong>{{ $t('legalNotice.registeredAddress') }}</strong></p>
      <p>{{ $t('legalNotice.address') }}</p>
      <p>Email: <a href="mailto:hello@webeasy.pro">hello@webeasy.pro</a></p>
    </section>
    <section>
      <h2>{{ $t('legalNotice.hosting') }}</h2>
      <p>{{ $t('legalNotice.hostingText1') }}</p>
      <p><strong>OVH SAS</strong></p>
      <p>{{ $t('legalNotice.hostingText2') }}</p>
      <p>{{ $t('legalNotice.hostingText3') }}</p>
      <p>{{ $t('legalNotice.hostingText4') }}</p>
    </section>
    <section>
      <h2>{{ $t('legalNotice.liability') }}</h2>
      <p>{{ $t('legalNotice.liabilityText1') }}</p>
      <p>{{ $t('legalNotice.liabilityText2') }}</p>
    </section>
    <section>
      <h2>{{ $t('legalNotice.intellectualProperty') }}</h2>
      <p>{{ $t('legalNotice.intellectualPropertyText') }}</p>
    </section>
    <section>
      <h2>{{ $t('legalNotice.personalData') }}</h2>
      <p>{{ $t('legalNotice.personalDataText1') }}</p>
      <p>{{ $t('legalNotice.personalDataText2') }}</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'LegalNoticePage',
};
</script>

<style scoped>
.legal-notice {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  line-height: 1.6;
}
a {
  color: #5295FF;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
